import { atom } from 'jotai';
import { IPrimaryComment } from 'shared/models/comments';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

const $ArticleCommentStore = atom<any>({});

export interface IArticleComments {
  items: IPrimaryComment[];
  hasMore: boolean;
  cursor: number;
}

export const $ArticleComments = safeAtomFamily((groupId: string) => {
  const a = atom<IArticleComments | Promise<IArticleComments>, [IArticleComments | Promise<IArticleComments>], void>(
    (get) => {
      return get($ArticleCommentStore)[groupId] || new Promise(() => void 0);
    },
    (get, set, comments) => {
      const old = get($ArticleCommentStore);
      set($ArticleCommentStore, { ...old, [groupId]: comments });
    },
  );

  a.debugLabel = `$ArticleComments+${encodeURIComponent(groupId)}`;

  return a;
});
